import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "サバイバルでもかわいいピグリンたちと一緒に冒険したい！！", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("そんな願いが叶うデータパック"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://sayanosasa.com/e/friendship-with-piglin",
    target: "_blank"
  }, "『Friendship with Piglin!』"),
  /*#__PURE__*/_createTextVNode("を鞘笹さんが配布されています！")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "一緒にDLして遊んでみてはいかがでしょうか！", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "※『Friendship with Piglin!』は斜向とは無関係です。利用規約などは別途ご確認ください。", -1)

import TitleCard from '@/components/utils/TitleCard.vue';
import BaseArticle from '@/components/Works/baseArticle.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CutieTrickView',
  setup(__props) {

const videoIds = [
  'wqiobdp_bnA',
  'di2BPEWqSVY',
]

return (_ctx: any,_cache: any) => {
  const _component_q_video = _resolveComponent("q-video")!

  return (_openBlock(), _createBlock(BaseArticle, {
    "product-name": "Cutie-Trick!!",
    imgsrc: require('@/assets/Works/Others/cutie_trick.png'),
    "download-link": "https://drive.google.com/uc?id=1TUPhD7HfmB7BHOQmXhGI06jH8GntrqQk"
  }, {
    default: _withCtx(() => [
      _createVNode(TitleCard, {
        title: "マイクラのハロウィンを更に楽しく！",
        abst: [
        'かわいい魔女が!?',
        'かわいいピグリンが!?',
        'リソースパックでハロウィンを楽しもう！',
      ]
      }),
      _createVNode(TitleCard, { title: "かわいいピグリンと一緒に冒険!?" }, {
        abst: _withCtx(() => [
          _hoisted_1,
          _hoisted_2,
          _hoisted_3,
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(TitleCard, { title: "紹介映像" }, {
        abst: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(videoIds, (id) => {
            return _createVNode(_component_q_video, {
              key: id,
              src: `https://www.youtube.com/embed/${id}`,
              class: "innerAssets q-pa-md"
            }, null, 8, ["src"])
          }), 64))
        ]),
        _: 1
      }),
      _createVNode(TitleCard, {
        title: "ダウンロード",
        abst: [
        '右下の丸いアイコンから、規約に同意することでダウンロードできます。',
        '対応バージョン：Minecraft 1.16.x',
        '必須ソフトウェア：OptiFine',
      ]
      }, null, 8, ["abst"])
    ]),
    _: 1
  }, 8, ["imgsrc"]))
}
}

})